import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TabComponent } from './tab/tab.component';
import { TabStepperComponent } from './tab-stepper.component';

@NgModule({
  declarations: [TabComponent, TabStepperComponent],
  imports: [CommonModule],
  exports: [TabComponent, TabStepperComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TabStepperModule {}
